/**
 * Утилита для работы с событиями DOM.
 */
const Emits = {
  /**
   * Добавляет слушатель события к элементу.
   *
   * @param {Element} el - DOM-элемент, к которому добавляется слушатель.
   * @param {string} event - Название события (например, 'click').
   * @param {EventListener} callback - Функция-обработчик события.
   */
  on(el, event, callback) {
    if (el) el.addEventListener(event, callback);
  },

  /**
   * Удаляет слушатель события с элемента.
   *
   * @param {Element} el - DOM-элемент, у которого удаляется слушатель.
   * @param {string} event - Название события.
   * @param {EventListener} callback - Функция-обработчик события, которую нужно удалить.
   */
  off(el, event, callback) {
    if (el) el.removeEventListener(event, callback);
  },

  /**
   * Делегирует событие от родительского элемента к дочерним элементам, соответствующим селектору.
   *
   * @param {Element} el - Родительский DOM-элемент, на который вешается делегирование.
   * @param {string} selector - CSS-селектор дочерних элементов, на которых будет срабатывать обработчик.
   * @param {string} event - Название события (например, 'click').
   * @param {EventListener} handler - Функция-обработчик события.
   */
  delegate(el, selector, event, handler) {
    el.addEventListener(event, function (e) {
      if (e.target.closest(selector)) {
        handler(e);
      }
    });
  },

  /**
   * Программно вызывает событие на элементе.
   *
   * @param {Element} el - DOM-элемент, на котором нужно вызвать событие.
   * @param {string} eventType - Тип события (например, 'click').
   */
  trigger(el, eventType) {
    if (el) {
      const event = new Event(eventType);
      el.dispatchEvent(event);
    }
  }
};

window.Emits = Emits;